import { render, staticRenderFns } from "./c-config-pane@.vue?vue&type=template&id=238ff923&"
import script from "./c-config-pane@.vue?vue&type=script&lang=ts&"
export * from "./c-config-pane@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports